import { request } from '@/shared/api/request'

export const sendDelWorkPlaceEsutd = ({data, params}) => {
	return request({ url: 'staff/wplace/sendEsutdDel', method: 'POST', data: data, params })
}
